import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import PoolProgramYear from "./RandomsModel/PoolProgramYear"
import PoolSelectionHistory from "./RandomsModel/PoolSelectionHistoryRow"



export default function GetPoolSelectionHistoryList(poolId: number, poolProgramId: number,  pageSize:number, pageNumber: number,): Observable<PoolSelectionHistory> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString(),
    poolProgramId: poolProgramId.toString(),
    pageSize: pageSize.toString(),
    pageNumber: pageNumber.toString()
  }).toString()

  return ObservableFromFetch<PoolSelectionHistory>("RandomTest/PoolSelectionHistoryList?" + requestBody)
}


export function GetPoolPrograms(poolId: number, count: number): Observable<PoolProgramYear[]> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString(),
    count: count.toString()
  }).toString()

  return ObservableFromFetch<PoolProgramYear[]>("RandomTest/GetPoolPrograms?" + requestBody)
}
